var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(['ResetPass', 'Dashboard', 'PageNotFound', 'Redirector'].indexOf(_vm.$route.name) == -1)?_c('Navbar'):_vm._e(),_c('v-main',{staticClass:"background"},[_c('router-view')],1),(_vm.$route.path === '/')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }